import React from 'react';
import Field from 'components/Form/Field';

const SectionNotFound = () => {
  const introTitle = `Section Not Found`;

  return (
    <div id="sectionNotFound">
      <h1 className="section-header">{introTitle}</h1>

      <Field title="Section Not Found" optional className="no-margin-bottom">
        You&apos;ve reached an invalid section.
      </Field>
    </div>
  );
};

export default SectionNotFound;
